import React, { useState } from "react";
import { FaEye, FaEyeSlash } from "react-icons/fa"; // Importing the eye icons
import { encodeQueryParameter } from "../../../CommonFunctions";
import config from "../../../config";

interface SignInFormProps {
  setIsLogin: (value: boolean) => void;
  setForgotPassword: (value: boolean) => void;
  fundraiserID?: string;
}

const SigninForm: React.FC<SignInFormProps> = ({
  setIsLogin,
  setForgotPassword,
  fundraiserID,
}) => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false); // Toggle password visibility
  const [loading, setLoading] = useState(false);
  const [formMessage, setFormMessage] = useState({
    message: "",
    isError: false,
  });

  const handleLogin = async (e: React.FormEvent) => {
    e.preventDefault();
    setFormMessage({ message: "", isError: false });
    setLoading(true);

    try {
      const encodedPassword = encodeQueryParameter({ password });
      const baseUrl = config.API_BASE_URL;
      const endpoint = "token/";
      const response = await fetch(`${baseUrl}${endpoint}`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ email, password: encodedPassword }),
      });

      if (response.ok) {
        const data = await response.json();
        localStorage.setItem("accessToken", data.access);
        localStorage.setItem("refreshToken", data.refresh);

        if (fundraiserID) {
          const encodedReroute = encodeQueryParameter({
            fundraiser_id: fundraiserID,
          });
          window.location.href = `/fundraiser/join-fundraiser/${encodedReroute}`;
        } else {
          window.location.href = "/dashboard/user";
        }
      } else {
        const errorData = await response.json();
        setFormMessage({
          message: `${errorData["non_field_errors"][0] || "Login failed"}`,
          isError: true,
        });
      }
    } catch (error) {
      setFormMessage({
        message: "Login information not found or is incorrect",
        isError: true,
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <form onSubmit={handleLogin}>
      <div className="mb-3">
        <input
          type="email"
          className="login-page-form-control"
          placeholder="Email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
        />
      </div>
      <div className="mb-3 position-relative">
        <input
          type={showPassword ? "text" : "password"} // Dynamically set type
          className="login-page-form-control"
          placeholder="Password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          required
        />
        <span
          className="password-toggle-icon"
          onClick={() => setShowPassword(!showPassword)} // Toggle visibility
          style={{
            position: "absolute",
            right: "10px",
            top: "50%",
            transform: "translateY(-50%)",
            cursor: "pointer",
          }}
        >
          {showPassword ? <FaEyeSlash size={20} /> : <FaEye size={20} />}
        </span>
      </div>
      {formMessage.message && (
        <p className={formMessage.isError ? "text-danger" : "text-success"}>
          {formMessage.message}
        </p>
      )}
      <button type="submit" className="btn login-page-btn" disabled={loading}>
        {loading ? "Logging in..." : "Login"}
      </button>
    </form>
  );
};

export default SigninForm;
